export const FETCH_MOULD_REQUEST = 'FETCH_MOULD_REQUEST';
export const FETCH_MOULD_SUCCESS = 'FETCH_MOULD_SUCCESS';
export const FETCH_MOULD_FAILURE = 'FETCH_MOULD_FAILURE';

export const ADD_MOULD_REQUEST = 'ADD_MOULD_REQUEST';
export const ADD_MOULD_SUCCESS = 'ADD_MOULD_SUCCESS';
export const ADD_MOULD_FAILURE = 'ADD_MOULD_FAILURE';

export const UPDATE_MOULD_REQUEST = 'UPDATE_MOULD_REQUEST';
export const UPDATE_MOULD_SUCCESS = 'UPDATE_MOULD_SUCCESS';
export const UPDATE_MOULD_FAILURE = 'UPDATE_MOULD_FAILURE';

export const DELETE_MOULD_REQUEST = 'DELETE_MOULD_REQUEST';
export const DELETE_MOULD_SUCCESS = 'DELETE_MOULD_SUCCESS';
export const DELETE_MOULD_FAILURE = 'DELETE_MOULD_FAILURE';

export const MOULD_FORM_ERROR = 'MOULD_FORM_ERROR';
export const MOULD_FORM_SUCCESS = 'MOULD_FORM_SUCCESS';
export const SET_MOULD_EDIT = 'SET_MOULD_EDIT';
export const CLEAR_MOULD_EDIT = 'CLEAR_MOULD_EDIT'; 